import React, { useEffect, useState } from 'react'
import { Alert, Col, Row } from 'antd';
import { isEmpty } from 'lodash';
import { translate } from 'react-i18next';

const AnnouncementHead = ({ t, jwt }) => {
    const [announcementMsg, setAnnouncementMsg] = useState('')

    useEffect(() => {
        if (!isEmpty(jwt)) {
            setAnnouncementMsg(t('lobby_participant.announcement_1'))
        } else {
            setAnnouncementMsg(t('lobby_participant.announcement_2'))
        }

    }, [jwt, t])

    return (
        <Row>
            <Col span={24}>
                <Alert
                    className="participant-alert"
                    message={announcementMsg}
                    type="error"
                />
            </Col>
        </Row>
    )
}

export default translate()(AnnouncementHead)
